import { z } from 'zod'

/**
 * The tags a venue already uses, most-used first, for suggesting as someone
 * types. Tags are free text, so this list is the only thing keeping the set
 * from sprawling — it is a prompt, never a restriction.
 */
export const furnitureTagsDtoSchema = z.object({
  tags: z.array(z.string()),
})

export type FurnitureTagsDto = z.infer<typeof furnitureTagsDtoSchema>
